import AuthSlice from '@/auth/sagaSlice';
import UsersSlice from '@/users/sagaSlice';
import PropertySlice from '@/properties/sagaSlice';
import UnitTypeSlice from '@/_unit-types/sagaSlice';
import UnitSlice from '@/units/sagaSlice';
import EmployeeSlice from '@/employees/sagaSlice';
import TitleSlice from '@/titles/sagaSlice';
import EvalQuestionSlice from '@/eval-questions/sagaSlice';
import EvalSlice from '@/evals/sagaSlice';
import ReportsSlice from '@/delinquencies/sagaSlice';
import DocumentsSlice from '@/documents/sagaSlice';
import _OrdersSlice from '../src/components/_orders/sagaSlice';
import NotariesSlice from '@/notaries/sagaSlice';
import LawyersSlice from '@/lawyers/sagaSlice';
import DepartmentsSlice from '@/departments/sagaSlice';
import RenewalsSlice from '@/renewals/sagaSlice';
import SidebarSlice from '+/nav/navSlice';

const modules = [
    AuthSlice,
    UsersSlice,
    PropertySlice,
    UnitTypeSlice,
    UnitSlice,
    TitleSlice,
    EmployeeSlice,
    EvalQuestionSlice,
    EvalSlice,
    ReportsSlice,
    DocumentsSlice,
    _OrdersSlice,
    NotariesSlice,
    LawyersSlice,
    DepartmentsSlice,
    RenewalsSlice,
    SidebarSlice
];

export default modules;
